import { Component, Input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { environment } from '../../../environments/environment';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { RouterModule } from '@angular/router';


@Component({
  selector: 'app-content-area2',
  imports: [SafeHtmlPipe, RouterModule, NgOptimizedImage],
  templateUrl: './content-area2.component.html',
  styleUrl: './content-area2.component.scss'
})
export class ContentArea2Component {
  assetsCDNUrl = environment.assetsCDNUrl;

  @Input() solutionData: any;

}
